import { StyleSheet, Text, View } from "react-native";
import { useTranslation } from "@luna-restaurant/i18n";
import { FontAwesomeKitIcon, useCustomTheme } from "@luna-restaurant/ui";
export const DessertsCard = ({ desserts }) => {
    const { t } = useTranslation();
    const { colors, fonts } = useCustomTheme();
    if (desserts.length === 0) {
        return null;
    }
    return (<View style={[styles.container, { backgroundColor: colors.palette.carrot100 }]}>
      <View style={styles.header}>
        <FontAwesomeKitIcon name="cupcake" size={14} color={colors.palette.carrot20}/>
        <Text style={[
            styles.title,
            { ...fonts.semiBold, color: colors.palette.carrot20 },
        ]}>
          {t("desserts.title").toUpperCase()}
        </Text>
      </View>

      <View style={styles.dessertsList}>
        {desserts.map((dessert, index) => (<View key={index} style={styles.dessertItem}>
            <span style={{
                ...styles.dessertText,
                ...fonts.medium,
                color: colors.palette.carrot20,
            }}>
              •{" "}
            </span>
            <span style={{
                ...styles.dessertText,
                ...fonts.medium,
                color: colors.palette.carrot20,
            }} dangerouslySetInnerHTML={{ __html: dessert }}/>
          </View>))}
      </View>
    </View>);
};
const styles = StyleSheet.create({
    container: {
        borderRadius: 4,
        padding: 8,
        paddingBottom: 12,
    },
    header: {
        flexDirection: "row",
        alignItems: "center",
        marginBottom: 10,
        paddingHorizontal: 4,
        gap: 4,
    },
    title: {
        fontSize: 12,
        letterSpacing: 1.02,
        marginTop: 2,
    },
    dessertsList: {
        paddingLeft: 4,
    },
    dessertItem: {
        flexDirection: "row",
        alignItems: "flex-start",
    },
    dessertText: {
        fontSize: 15,
        marginLeft: 4,
    },
});
//# sourceMappingURL=DessertsCard.web.js.map